import { useEffect } from "react";

const DEFAULT_TITLE = "Fast STAR Smog Check in Hayward, CA | BaySmog — 258 W Tennyson Rd";
const SITE_URL = "https://baysmog.com";

const setMeta = (attr, key, value) => {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Fully automatic SEO: title, meta description, keywords, canonical, Open Graph and
// Twitter tags are generated from each page's own content — no manual management.
export const SEO = ({ title, description, keywords, path }) => {
  useEffect(() => {
    const p = path || window.location.pathname;
    const url = `${SITE_URL}${p}`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setCanonical(url);
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title, description, keywords, path]);
  return null;
};
